import React, { FC } from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import Img, { FluidObject } from "gatsby-image";

import { mediaQuery } from "src/themes/breakpoints";
import Heading, { HeadingScope, HeadingVariant } from "src/components/Heading";
import Button, { ButtonAppearance } from "src/components/Button";

const Wrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ImageWrapper = styled.div`
  width: 100%;
`;

const StyledLink = styled(Link)`
  width: 100%;
`;

const Title = styled(Heading)`
  padding: 10px 0;
  ${mediaQuery("lg")} {
    min-height: 100px;
  }
`;

interface BlogCardProps {
  image: FluidObject;
  title: string;
  slug: string;
}

const BlogCard: FC<BlogCardProps> = ({ image, title, slug }) => (
  <Wrapper>
    <StyledLink to={slug}>
      <ImageWrapper>
        <Img fluid={image} alt={title} />
      </ImageWrapper>
      <HeadingScope>
        <Title variant={HeadingVariant.DELTA}>{title}</Title>
      </HeadingScope>
    </StyledLink>
    <Button url={slug} appearance={ButtonAppearance.ALFA}>
      Lesen
    </Button>
  </Wrapper>
);

export default BlogCard;
